import React from 'react';
import AMPPage from '../AMPPage';
import AMPPageHeader from '../AMPPageHeader';
import AMPPageSection from '../AMPPageSection';

export default function PrivacyPolicyPage() {
  return (
    <AMPPage>
      <AMPPageHeader title="Anchor FM Inc." subtitle="DMCA Copyright Policy" />
      <AMPPageSection>
        <p className="c5">
          <span className="c1">Anchor FM Inc. (&ldquo;</span>
          <span className="c14">Company</span>
          <span className="c1">
            &rdquo;) has adopted the following general policy toward copyright
            infringement in accordance with the Digital Millennium Copyright Act
            (
          </span>
          <span className="c15 c33">
            <a href="http://lcweb.loc.gov/copyright/legislation/dmca.pdf">
              http://lcweb.loc.gov/copyright/legislation/dmca.pdf
            </a>
          </span>
          <span className="c1">
            ) and other applicable intellectual property laws. The address of
            the Designated Agent to Receive Notification of Claimed Infringement
            (&ldquo;
          </span>
          <span className="c14">Designated Agent</span>
          <span className="c1">
            &rdquo;) is listed at the end of this policy.
          </span>
        </p>
        <p className="c4">
          <span className="c32 c18 c23">
            Procedure for Reporting Copyright Infringement:
          </span>
        </p>
        <p className="c2">
          <span className="c1" />
        </p>
        <p className="c4">
          <span className="c1">
            If you believe that material or content residing on or accessible
            through Company&rsquo;s websites or services infringes a copyright,
            please send a notice of copyright infringement containing the
            following information to the Designated Agent listed below:
          </span>
        </p>
        <p className="c4 c7 c30">
          <span className="c1" />
        </p>
        <ul className="c10 lst-kix_list_2-0 start">
          <li className="c4 c9">
            <span className="c1">
              A physical or electronic signature of a person authorized to act
              on behalf of the owner of the copyright that has been allegedly
              infringed;
            </span>
          </li>
        </ul>
        <p className="c4 c7 c21">
          <span className="c1" />
        </p>
        <ul className="c10 lst-kix_list_3-0 start">
          <li className="c4 c9">
            <span className="c1">
              Identification or description of works or materials being
              infringed;
            </span>
          </li>
        </ul>
        <p className="c4 c21 c7">
          <span className="c1" />
        </p>
        <ul className="c10 lst-kix_list_4-0 start">
          <li className="c4 c9">
            <span className="c1">
              Identification or description of the material that is claimed to
              be infringing, including information regarding the location on the
              Anchor FM Platform of the infringing materials that the copyright
              owner seeks to have removed, with sufficient detail so that
              Company is capable of finding and verifying its existence;
            </span>
          </li>
        </ul>
        <p className="c4 c7">
          <span className="c1" />
        </p>
        <ul className="c10 lst-kix_list_7-0 start">
          <li className="c4 c9">
            <span className="c1">
              Contact information about the notifying party including address,
              telephone number and, if available, e-mail address;
            </span>
          </li>
        </ul>
        <p className="c4 c7">
          <span className="c1" />
        </p>
        <ul className="c10 lst-kix_list_8-0 start">
          <li className="c4 c9">
            <span className="c1">
              A statement that the notifying party has a good faith belief that
              the material is not authorized by the copyright owner, its agent,
              or the law; and
            </span>
          </li>
        </ul>
        <p className="c4 c7">
          <span className="c1" />
        </p>
        <ul className="c10 lst-kix_list_9-0 start">
          <li className="c4 c9">
            <span className="c1">
              A statement by the notifying party made under penalty of perjury
              that the information provided is accurate and the notifying party
              is the copyright owner or authorized to make the complaint on
              behalf of the copyright owner.
            </span>
          </li>
        </ul>
        <p className="c4 c7">
          <span className="c1" />
        </p>
        <p className="c12">
          <span className="c18 c23">Counter-Notice</span>
          <span className="c18">
            : If you believe that your content that was removed (or to which
            access was disabled) is not infringing, or that you have the
            authorization from the copyright owner, the copyright owner&rsquo;s
            agent, or pursuant to the law, to upload and use your content, you
            may send a written counter-notice containing the following
            information to the Copyright Agent:{' '}
          </span>
        </p>
        <p className="c12 c7">
          <span className="c18" />
        </p>
        <ol className="c10 lst-kix_list_10-0 start" start="1">
          <li className="c11 c16">
            <span className="c15">Your physical or electronic signature; </span>
          </li>
        </ol>
        <p className="c0">
          <span className="c15" />
        </p>
        <ol className="c10 lst-kix_list_10-0" start="2">
          <li className="c4 c11">
            <span className="c15">
              Identification of the content that has been removed or to which
              access has been disabled and the location at which the content
              appeared before it was removed or disabled;{' '}
            </span>
          </li>
        </ol>
        <p className="c19 c7 c25">
          <span className="c15" />
        </p>
        <ol className="c10 lst-kix_list_10-0" start="3">
          <li className="c4 c11">
            <span className="c15">
              A statement that you have a good faith belief that the content was
              removed or disabled as a result of mistake or a misidentification
              of the content; and{' '}
            </span>
          </li>
        </ol>
        <p className="c19 c7 c25">
          <span className="c15" />
        </p>
        <ol className="c10 lst-kix_list_10-0" start="4">
          <li className="c26 c11 c29">
            <span className="c15">
              Your name, address, telephone number, and email address, a
              statement that you consent to the jurisdiction of the federal
              court located within the Southern District of New York and a
              statement that you will accept service of process from the person
              who provided notification of the alleged infringement.{' '}
            </span>
          </li>
        </ol>
        <p className="c8">
          <span className="c15">
            If a counter-notice is received by the Copyright Agent, Company will
            send a copy of the counter-notice to the original complaining party
            informing that person that it may replace the removed content or
            cease disabling it in 10 business days. Unless the copyright owner
            files an action seeking a court order against the content provider,
            member or user, the removed content may be replaced, or access to it
            restored, in 10 to 14 business days or more after receipt of the
            counter-notice, at our sole discretion.
          </span>
        </p>
        <p className="c7 c26">
          <span className="c18 c23" />
        </p>
        <p className="c4">
          <span className="c18 c23 c32">Repeat Infringer Policy</span>
          <span className="c1">
            : &nbsp;In accordance with the Digital Millennium Copyright Act and
            other applicable law, Company has adopted a policy of terminating,
            in appropriate circumstances and at Company&#39;s sole discretion,
            users who are deemed to be repeat infringers. &nbsp;Company may also
            at its sole discretion limit access to the Anchor FM Platform and/or
            terminate the memberships of any users who infringe any intellectual
            property rights of others, whether or not there is any repeat
            infringement.
          </span>
        </p>
        <p className="c4 c7">
          <span className="c1" />
        </p>
        <p className="c4 c31">
          <span className="c1">
            Please contact the Designated Agent to Receive Notification of
            Claimed Infringement for Company at{' '}
          </span>
          <span className="c14">
            <a href="mailto:dmca@anchor.fm">dmca@anchor.fm</a>
          </span>
          <span className="c1">&nbsp;or at:</span>
        </p>
        <p className="c3">
          <span className="c1" />
        </p>
        <p className="c6 c7">
          <span className="c1" />
        </p>
        <p className="c6">
          <span className="c1">Spotify C/O Anchor</span>
        </p>
        <p className="c6">
          <span className="c18">150 Greenwich St</span>
        </p>
        <p className="c6">
          <span className="c18">New York, NY 10007</span>
        </p>
        <div>
          <p className="c19">
            <span className="c23 c24">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </p>
          <p className="c7 c28">
            <span />
          </p>
        </div>
      </AMPPageSection>
    </AMPPage>
  );
}
